module.exports = __webpack_public_path__ + "bc5f74010cd8bf9fd90f6782605f6c76.pdf";